import { HTMLAttributes } from 'react'
import * as React from 'react'
import { SectionHeaderContainer } from './styles'

type Props = HTMLAttributes<HTMLDivElement> & {
  isOpened?: boolean
  isStepByStepFlow?: boolean
}

export const SectionHeader: React.FC<Props> = props => {
  const { children, isOpened, isStepByStepFlow, ...rest } = props

  return (
    <SectionHeaderContainer $isOpened={isOpened} $isStepByStepFlow={isStepByStepFlow} {...rest}>
      {children}
    </SectionHeaderContainer>
  )
}
